import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Capsule from '@zyf2e/capsule-ui';
import '@zyf2e/capsule-ui/lib/theme-chalk/index.css';
import '@/style/capsule-variables.scss';
import '@/style/common.scss';
import PreviewImg from '@/components/PreviewImg';
import PreviewImgList from '@/components/PreviewImgList';
import { registerModule } from '@zyf2e/zim-ecology/lib/pcstore';
import clipboard from 'clipboard';
import ZYPay from '@zyf2e/checkout-sdk';
import { getZYPayBaseUrl } from '@/utils'

//TODO: 测试用
Vue.prototype.$previewImg = PreviewImg;
Vue.prototype.$previewImgList = PreviewImgList;
Vue.prototype.clipboard = clipboard;

const zyPayBaseUrl = getZYPayBaseUrl()
ZYPay.init({
  bizId: 'B2B_SCM',
  bizSource: 'B2B_MALL',
  baseURL: zyPayBaseUrl,
});

Vue.prototype.$zyPay = ZYPay;

Vue.directive('track-event', Telescope.vTrackEvent);

Vue.config.productionTip = false;
Vue.use(Capsule);
registerModule(store);
const VM = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

export default VM;
